import './localization';

// Register game plugins
import './games/marble-roulette';

import { PlatformManager } from './platform/PlatformManager';
import { UIController } from './platform/UIController';

const platform = new PlatformManager();
const ui = new UIController(platform);
ui.init();
